import { render, staticRenderFns } from "./VariantItemOption.vue?vue&type=template&id=8207f548&scoped=true"
import script from "./VariantItemOption.vue?vue&type=script&lang=js"
export * from "./VariantItemOption.vue?vue&type=script&lang=js"
import style0 from "./VariantItemOption.vue?vue&type=style&index=0&id=8207f548&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8207f548",
  null
  
)

export default component.exports